import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export type TCssClassDef = ClassValue;

// * Why
// https://www.youtube.com/watch?v=re2JFITR7TI
// https://github.com/dcastil/tailwind-merge/blob/v2.2.1/docs/what-is-it-for.md
// https://github.com/dcastil/tailwind-merge/discussions/137#discussioncomment-3482513

// * Libs
// https://github.com/dcastil/tailwind-merge?tab=readme-ov-file
// https://github.com/lukeed/clsx

/**
 * A utility function to merge Tailwind CSS classes.
 * Allows conditional classes and arrays of classes as well.
 */
export const cn = (...args: ClassValue[]) => {
  return twMerge(clsx(args));
};
